// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"d2391b4e","11":"29096c16","356":"1fb74ae3","453":"453f2ef2","639":"a026425b","717":"cdda2f6e","721":"92527955","781":"631a4e4b","803":"7f45d15c","908":"5db8e246"}[chunkId] + ".chunk.js";
};